/* eslint-disable */
import $ from 'jquery';
import BaseModule from './BaseModule';

export default class FocusExpand extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'FocusExpand');

    const inputEmail = $(el).find('input[type=email]');
    inputEmail.on('focus', function () {
      $(this).parent('.input-wrapper').siblings('.will-expand').slideDown();
    })
  }
}
